module.exports = __webpack_public_path__ + "assets/img/shop_detail_img3.1e019dcc.png";